import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Logout, SuccessBannerProvider } from '@aserto/console-common'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { NavBar } from './components/NavBar'

const DirectoryBrowser = React.lazy(() => import('./views/DirectoryBrowser'))
const Error = React.lazy(() => import('./views/Error'))
const PolicyInstance = React.lazy(() => import('./views/PolicyInstance'))
const ConfigurationsSettings = React.lazy(() => import('./views/ConfigurationsSettings'))
const Index = React.lazy(() => import('./views/Index'))
const AuthorizerApiDocs = React.lazy(() => import('./views/ApiDocs/authorizer'))
const DirectoryApiDocs = React.lazy(() => import('./views/ApiDocs/directory'))

function App() {
  return (
    <div id="root">
      <NavBar />
      <SuccessBannerProvider>
        <Suspense fallback={<></>}>
          <Routes>
            <Route element={<Logout />} path="/logout" />
            <Route element={<Index />} path="/" />
            <Route element={<Error />} path="/error" />
            <Route element={<AuthorizerApiDocs />} path="/ui/apidocs/authorizer" />
            <Route element={<DirectoryApiDocs />} path="/ui/apidocs/directory" />
            <Route element={<PolicyInstance />} path="/ui/authorizer/*" />
            <Route element={<ConfigurationsSettings />} path="/ui/settings" />
            <Route element={<DirectoryBrowser />} path="/ui/directory/*" />
            <Route element={<Navigate replace to="/" />} path="*" />
          </Routes>
        </Suspense>
      </SuccessBannerProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </div>
  )
}

export default App
